module.exports = __webpack_public_path__ + "img/save_filled_24.2392e72e.svg";